import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ComTabla from './ComTabla';
import './VerCom.css';
import { useTranslation } from 'react-i18next';
import Comparativa from './Comparativas';

function VerCom() {
    const { t } = useTranslation();
    var [code, setCode] = useState(null);
    if (code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    window.addEventListener("orientationchange", function () {
        window.location.reload();
    });

    return (
        <div className='div-tabs-meteo'>
            <Tabs defaultActiveKey="datos">
                <Tab eventKey="datos" title={t('scada.solarFarm.comparatives.table')}>
                    <ComTabla code={code} />
                </Tab>
                <Tab eventKey="comprativas" title={t('scada.solarFarm.comparatives.comparatives')}>
                    <Comparativa code={code} />
                </Tab>
            </Tabs>
        </div>
    );
};

export default VerCom;